import { createAction } from '@reduxjs/toolkit';

export const editTodo = createAction('editTodo');
